// Tratamientos.js
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './tratamientos.css';
import imagen1 from '../../assets/bruxismo_11.jpg';
import imagen2 from '../../assets/facial_8.jpg';
import imagen3 from '../../assets/facial_7.jpg';
import imagen4 from '../../assets/facial_13.jpg';
import imagen5 from '../../assets/facial_16.jpg';
import imagen6 from '../../assets/facial_20.jpg';
import imagen7 from '../../assets/facial_14.jpg';
import imagen8 from '../../assets/facial_3.jpg';
import imagen9 from '../../assets/facial_18.jpg';
import imagen10 from '../../assets/facial_30.jpg';
import imagen11 from '../../assets/facial_36.jpg';
import imagen12 from '../../assets/facial_34.jpg';
import imagen13 from '../../assets/facial_39.jpg';
import imagen14 from '../../assets/peeling.jpg';
import imagen15 from '../../assets/pomulos.jpg';
import imagen16 from '../../assets/plasma.jpg';
import imagen17 from '../../assets/profhilo.jpg';
import imagen18 from '../../assets/rinomodelacion.jpg';
import imagen19 from '../../assets/surcos.jpg';
import imagen20 from '../../assets/sustentacion.jpg';
import imagen21 from '../../assets/botulinica.jpg';
import imagen22 from '../../assets/radiofrecuencia_1.jpg';
import imagen23 from '../../assets/microagujas_3.jpg';
import imagen24 from '../../assets/fototerapia.jpg';
import imagen25 from '../../assets/enzimas.jpg';
import imagen26 from '../../assets/sueroterapia.jpg';
import imagen27 from '../../assets/tensamax.jpg';
import imagen28 from '../../assets/emsculpt.jpg';
import imagen29 from '../../assets/microagujas.jpg';
import imagen30 from '../../assets/masaje.jpg';
import imagen31 from '../../assets/celulitis.jpg';
import imagen32 from '../../assets/maderoterapia.jpg';
import imagen33 from '../../assets/relajante.jpg';
import imagen34 from '../../assets/mesoterapia.jpg';
import imagen35 from '../../assets/mesoterapia_2.jpg';
import imagen36 from '../../assets/plasma_capilar.jpg';

const tratamientos = [
  { 
    id: 1,
    categoria: 'facial',
    nombre: 'bruxismo',
    imagen: imagen1,
    url: '/servicios/bruxismo'
  },
  { 
    id: 2,
    categoria: 'facial',
    nombre: 'contorno manidibular',
    imagen: imagen2,
    url: '/servicios/contorno-mandibular'
  },
  { 
    id: 3,
    categoria: 'facial',
    nombre: 'Enzimas',
    imagen: imagen3,
    url: '/servicios/enzimas'
  },
  { 
    id: 4,
    categoria: 'facial',
    nombre: 'Exosomas',
    imagen: imagen4,
    url: '/servicios/exosomas'
  },
  { 
    id: 5,
    categoria: 'facial',
    nombre: 'Estimuladores de colageno',
    imagen: imagen5,
    url: '/servicios/estimuladores-de-colageno'
  },
  { 
    id: 6,
    categoria: 'facial',
    nombre: 'Hidratación',
    imagen: imagen6,
    url: '/servicios/hidratación'
  },
  { 
    id: 7,
    categoria: 'facial',
    nombre: 'Hiperhidrosis',
    imagen: imagen7,
    url: '/servicios/hiperhidrosis'
  },
  { 
    id: 8,
    categoria: 'facial',
    nombre: 'Hydrafacial®',
    imagen: imagen8,
    url: '/servicios/hydrafacial®'
  },
  { 
    id: 9,
    categoria: 'facial',
    nombre: 'Limpieza',
    imagen: imagen9,
    url: '/servicios/limpieza'
  },
  { 
    id: 10,
    categoria: 'facial',
    nombre: 'Labios',
    imagen: imagen10,
    url: '/servicios/labios'
  },
  { 
    id: 11,
    categoria: 'facial',
    nombre: 'Mentón',
    imagen: imagen11,
    url: '/servicios/mentón'
  },
  { 
    id: 12,
    categoria: 'facial',
    nombre: 'Nanopore',
    imagen: imagen12,
    url: '/servicios/nanopore'
  },
  { 
    id: 13,
    categoria: 'facial',
    nombre: 'Ojeras',
    imagen: imagen13,
    url: '/servicios/ojeras'
  },
  { 
    id: 14,
    categoria: 'facial',
    nombre: 'Peeling',
    imagen: imagen14,
    url: '/servicios/peeling'
  },
  { 
    id: 15,
    categoria: 'facial',
    nombre: 'Pómulos',
    imagen: imagen15,
    url: '/servicios/pómulos'
  },
  { 
    id: 16,
    categoria: 'facial',
    nombre: 'Plasma',
    imagen: imagen16,
    url: '/servicios/plasma'
  },
  { 
    id: 17,
    categoria: 'facial',
    nombre: 'Acido hialuronico',
    imagen: imagen17,
    url: '/servicios/acido-hialuronico'
  },
  { 
    id: 18,
    categoria: 'facial',
    nombre: 'Rinomodelacion',
    imagen: imagen18,
    url: '/servicios/rinomodelacion'
  },
  { 
    id: 19,
    categoria: 'facial',
    nombre: 'Surcos',
    imagen: imagen19,
    url: '/servicios/surcos'
  },
  { 
    id: 20,
    categoria: 'facial',
    nombre: 'Sustentación',
    imagen: imagen20,
    url: '/servicios/sustentación'
  },
  { 
    id: 21,
    categoria: 'facial',
    nombre: 'Toxina Botulinica',
    imagen: imagen21,
    url: '/servicios/toxina-botulinica'
  },
  { 
    id: 22,
    categoria: 'facial',
    nombre: 'Radiofrecuencia',
    imagen: imagen22,
    url: '/servicios/radiofrecuencia'
  },
  { 
    id: 23,
    categoria: 'facial',
    nombre: 'Radiofrecuencia fraccionada con microagujas',
    imagen: imagen23,
    url: '/servicios/radiofrecuencia-fraccionada-con-microagujas'
  },
  { 
    id: 24,
    categoria: 'facial',
    nombre: 'Fototerapia',
    imagen: imagen24,
    url: '/servicios/fototerapia'
  },
  { 
    id: 25,
    categoria: 'corporal',
    nombre: 'Enzimas 2 generación',
    imagen: imagen25,
    url: '/servicios/enzimas-2-generación'
  },
  { 
    id: 26,
    categoria: 'corporal',
    nombre: 'Sueroterapia',
    imagen: imagen26,
    url: '/servicios/sueroterapia'
  },
  { 
    id: 27,
    categoria: 'corporal',
    nombre: 'Tensamax',
    imagen: imagen27,
    url: '/servicios/tensamax'
  },
  { 
    id: 28,
    categoria: 'corporal',
    nombre: 'EMSculpt',
    imagen: imagen28,
    url: '/servicios/emsculpt'
  },
  { 
    id: 29,
    categoria: 'corporal',
    nombre: 'Radiofrecuencia fraccionada microagujas corporal',
    imagen: imagen29,
    url: '/servicios/radiofrecuencia-fraccionada-microagujas-corporal'
  },
  { 
    id: 30,
    categoria: 'corporal',
    nombre: 'Masajes reductores y moldeamiento',
    imagen: imagen30,
    url: '/servicios/masajes-reductores-y-moldeamiento'
  },
  { 
    id: 31,
    categoria: 'corporal',
    nombre: 'Tratamiento para celulitis',
    imagen: imagen31,
    url: '/servicios/tratamiento-para-celulitis'
  },
  { 
    id: 32,
    categoria: 'corporal',
    nombre: 'Maderoterapia',
    imagen: imagen32,
    url: '/servicios/maderoterapia'
  },
  { 
    id: 33,
    categoria: 'corporal',
    nombre: 'Masaje relajante',
    imagen: imagen33,
    url: '/servicios/masaje-relajante'
  },
  { 
    id: 34,
    categoria: 'capilar',
    nombre: 'Exosomas capílar',
    imagen: imagen34,
    url: '/servicios/exosomas-capilar'
  },
  { 
    id: 35,
    categoria: 'capilar',
    nombre: 'Mesocapilar',
    imagen: imagen35,
    url: '/servicios/mesocapilar'
  },
  { 
    id: 36,
    categoria: 'capilar',
    nombre: 'Plasma capilar',
    imagen: imagen36,
    url: '/servicios/plasma-capilar'
  },
];

const Tratamientos = () => {
  const { categoria } = useParams();
  const tratamientosFiltrados = tratamientos.filter(t => t.categoria === categoria);

  return (
    <div className="app-container">
      <div className="contenedor">
        <Link to="/" className="volver-inicio">← Volver al inicio</Link>
        <h1>Tratamientos {categoria}</h1>
        
        <div className="grid-container">
          {tratamientosFiltrados.map((tratamiento) => (
            <div key={tratamiento.id} className="sistema-item">
              <h3>{tratamiento.nombre}</h3>
              
              <Link 
                to={tratamiento.url} 
                className="leer-mas-link"
              >
                Leer más →
              </Link>

              <div className="contenedor-imagen-circular">
                <img 
                  src={tratamiento.imagen} 
                  alt={tratamiento.nombre}
                  className="imagen-circular"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tratamientos;